<template>
  <div class="home">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="line-chart">
      <el-descriptions title="今日在线人数柱状图"></el-descriptions>
      <div class="chart-1">
        <div class="chart" ref="chart">
        </div>
      </div>
    </div>

    <div class="line-chart">
      <el-descriptions title="今日在线人数分布图"></el-descriptions>
      <div class="chart-2">
        <div class="chart" ref="chart_1">

        </div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    methods: {
      tableRowClassName({row, rowIndex}) {
        if (rowIndex === 1) {
          return 'warning-row';
        } else if (rowIndex === 3) {
          return 'success-row';
        }
        return '';
      },
      drawChart() {
        // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
        let myChart = this.$echarts.init(this.$refs.chart);
        // 指定图表的配置项和数据
        let option = {
          tooltip: {
            formatter(params){
              let circle = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:#4A90E2"></span>`;
              let seriesName = params.seriesName;
              let name = params.name;
              let value = params.value;
              return `${circle}${seriesName}<br />${name}: ${value}元`
            }
          },
          grid:{
            top:10,
            left:40,
            right:0,
            bottom:20,
            borderColor:'#d8d8d8'
          },
          xAxis: {
            data: ["魂斗罗", "超级玛丽", "拳皇", "坦克大战", "赛车", "刺客联盟","打地鼠"],
            axisLine: { show: true, lineStyle: { color: '#d8d8d8' } }, // 轴线
            splitLine: { show: false, lineStyle: { color: '#eeeeee' } }, // 分隔线
            axisTick: { show: true }, // 刻度
            axisLabel:{
              color:'#333'
            }
          },
          yAxis: {
            axisLine: { show: true, lineStyle: { color: '#d8d8d8' } }, // 轴线
            splitLine: { show: false, lineStyle: { color: '#eeeeee' } }, // 分隔线
            axisTick: { show: true }, // 刻度
            axisLabel:{
              color:'#333'
            }
          },
          color: [
            {
              type: 'linear',
              x: 1,
              y: 1,
              x2: 0,
              y2: 0,
              colorStops: [  // 设置颜色渐变
                { offset: 0, color: '#0272ED' },
                { offset: 1, color: '#F5814C' }
              ]
            }
          ],
          series: [
            {
              name: "销售额",
              type: "bar",
              data: [1048, 735, 580, 484, 300, 484, 300],
              barWidth:'60%'
            },
          ],
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
      },
      drawChart_1() {
        // 基于准备好的dom，初始化echarts实例  这个和上面的main对应
        let myChart = this.$echarts.init(this.$refs.chart_1);
        // 指定图表的配置项和数据
        let option = {
          tooltip: {
            trigger: 'item'
          },
          color: [
            new  this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#FC6679" },
              { offset: 1, color: "#FDC581" }
            ]),
            new  this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#91A6FD" },
              { offset: 1, color: "#8274ED" }
            ]),
            new  this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#02CEFC" },
              { offset: 1, color: "#0272ED" }
            ]),
            new  this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#7FC268" },
              { offset: 1, color: "#0BBBB7" }
            ]),
            new  this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: "#E7B115" },
              { offset: 1, color: "#F5814C" }
            ])
          ],
          series: [
            {
              name: '分布',
              type: 'pie',
              radius: [30, 150],
              roseType: 'area',
              itemStyle: {
                borderRadius: 8
              },
              avoidLabelOverlap: false,
              label: {
                show: true,
                position: 'outside',
                formatter: '{b}: ({d}%)'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '16',
                  fontWeight: 'bold',
                  formatter: '{b}: ({d}%)'
                },
                scale:true,
                scaleSize:10,

              },
              labelLine: {
                show: true
              },
              data: [
                { value: 1048, name: '魂斗罗' },
                { value: 735, name: '超级玛丽' },
                { value: 580, name: '拳皇' },
                { value: 484, name: '坦克大战' },
                { value: 300, name: '赛车' },
                { value: 484, name: '刺客联盟' },
                { value: 300, name: '打地鼠' }
              ]
            }
          ]
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
      },
    },
    data() {
      return {

      }
    },
    mounted(){
      this.drawChart()
      this.drawChart_1()
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  .home
    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }

    .line-chart
      width:100%;
      padding:0 100px;
      margin-top:30px;
      .chart-1
        width:100%;
        height:360px;
        .chart
          width:100%;
          height:100%;
      .chart-2
        width:100%;
        height:460px;
        .chart
          width:100%;
          height:100%;

</style>



// WEBPACK FOOTER //
// src/pages/Home/Home.vue